//Built-In
import React, {Fragment} from 'react';
//External
import {Col, Row} from "react-bootstrap";
import cx from "classnames";

//Internal
import HeaderComponent from "../Components/Campaigns/HeaderComponent";
import BodyComponent from "../Components/Campaigns/BodyComponent";
import FooterComponent from "../Components/Campaigns/FooterComponent";
import ButtonComponent from "../Components/Campaigns/ButtonComponent";
import CarouselComponent from "../Components/Campaigns/CarouselComponent";

export default class WhatsappComponent extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        let { waComponents, form, controller } = this.props;
        return (
            <Fragment>
                <Row className={cx({'hide' : waComponents['HEADER'] === undefined})}>
                    <Col md={'10'} className={'pr-0 d-grid mt-1'}>
                        {
                            waComponents['HEADER'] !== undefined &&
                            <HeaderComponent useForm={form} controller={controller} formData={this.props.formData} handleChange={this.props.handleTemplateChange} handleInputChange={this.props.handleInputChange} formDetail={this.props.leadFormDetail}
                                             onFileUpload={this.props.onFileUpload}
                                             errors={this.props.errors}
                                             component={waComponents['HEADER']}
                                             hideUpload={this.props.hideUpload} />
                        }
                    </Col>
                </Row>
                <Row className={cx({'hide' : waComponents['BODY'] === undefined})}>
                    <Col md={'10'} className={'pr-0 d-grid mt-1'}>
                        {
                            waComponents['BODY'] !== undefined &&
                            <BodyComponent 
                                source={`campaign`} 
                                useForm={form} 
                                controller={controller} 
                                values={this.props.formData} 
                                previewData={this.props.previewData} 
                                formDetail={this.props.leadFormDetail}
                                handleChange={this.props.handleTemplateChange}
                                handleInputChange={this.props.handleInputChange}
                                component={waComponents['BODY']} 
                            />
                        }
                    </Col>
                </Row>
                <Row className={cx({'hide' : waComponents['FOOTER'] === undefined})}>
                    <Col md={'10'} className={'pr-0 d-grid mt-2'}>
                        {
                            waComponents['FOOTER'] !== undefined &&
                            <FooterComponent component={waComponents['FOOTER']} />
                        }
                    </Col>
                </Row>
                <Row className={cx({'hide' : waComponents['BUTTONS'] === undefined})}>
                    <Col md={'10'} className={'pr-0 d-grid mt-2'}>
                        {
                            waComponents['BUTTONS'] !== undefined &&
                            <ButtonComponent component={waComponents['BUTTONS']} />
                        }
                    </Col>
                </Row>
                <Row className={cx({'hide' : waComponents['CAROUSEL'] === undefined})}>
                    <Col md={'10'} className={'pr-0 d-grid mt-2'}>
                        {
                            waComponents['CAROUSEL'] !== undefined &&
                            <CarouselComponent 
                                component={waComponents['CAROUSEL']} 
                                useForm={form}
                                controller={controller}
                                formData={this.props.formData}
                                previewData={this.props.previewData}
                                leadFormDetail={this.props.leadFormDetail}
                                handleChange={this.props.handleTemplateChange}
                                handleInputChange={this.props.handleInputChange}
                                onFileUpload={this.props.onFileUpload}
                                errors={this.props.errors}
                                hideUpload={this.props.hideUpload}
                            />
                        }
                    </Col>
                </Row>
            </Fragment>
        )
    }
}
